import { Component, forwardRef, HostBinding, Inject, Input, OnInit } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { BadgeSettings } from "../../service/style-configuration.service";
import { ServitlyBadgePipe } from "../../shared/pipe/servitly-badge.pipe";

@Component({
    selector: 'sy-badge',
    template: ''
})
export class ServitlyBadgeComponent implements OnInit {

    @Input() label: string;

    @Input() showLeadingIcon: boolean = true;

    @Input() colorTokenPrefix: string;

    @Input() colorToken: string;

    @Input() color: string;

    // trusted because the inline styles (color-mix) would otherwise be stripped by the Angular sanitizer
    @HostBinding('innerHTML') html: SafeHtml;

    constructor(
        @Inject(forwardRef(() => ServitlyBadgePipe)) private badgePipe: ServitlyBadgePipe,
        @Inject(forwardRef(() => DomSanitizer)) private sanitizer: DomSanitizer
    ) { }

    ngOnInit(): void {
        const settings: BadgeSettings = { colorTokenPrefix: this.colorTokenPrefix, colorToken: this.colorToken, color: this.color, showLeadingIcon: this.showLeadingIcon };
        this.html = this.sanitizer.bypassSecurityTrustHtml(this.label == null ? '' : this.badgePipe.transform(this.label, settings));
    }
}
